import { showToast, validateEmail } from '@/partials/el.Utils.js';

const SELECTOR = {
  TITLE_EL: '.js-product-title',
  CLOSE_BTN: '.js-close-button',
  TEMPLATE: 'template.js-template',
};

elabs.ComingSoonPopover = class {
  constructor(element) {
    if (!element) {
      return;
    }
    this.view = element;
    const templateElement = this.view.querySelector(SELECTOR.TEMPLATE);
    if (!templateElement) {
      return;
    }
    this.templateContent = templateElement.content;
    this.inited = false;
  }

  show(payload) {
    if (!this.inited) {
      this.init(payload);
    }

    this.variantId = payload.variantId;
    this.productId = payload.productId;
    this.titleElement.textContent = payload.title;
  }

  hide() {}

  init() {
    this.view.appendChild(this.templateContent.cloneNode(true));

    this.form = this.view.querySelector('form');
    this.titleElement = this.view.querySelector(SELECTOR.TITLE_EL);
    this.emailInput = this.form.querySelector('[type="email"]');
    this.emailSubmitButton = this.view.querySelector('.el-popover__newsletter-signup-button');

    const closeButton = this.view.querySelector(SELECTOR.CLOSE_BTN);

    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    closeButton.addEventListener('click', () => window.CenteredPopovers.wrapper.hide());

    this.emailInput.addEventListener('input', () => {
      this.toggleButtonVisibility();
    });

    window.addEventListener('CenteredPopoversWrapper:hide', () => {
      this.resetForm();
    });

    this.inited = true;
  }

  toggleButtonVisibility() {
    const hasText = this.emailInput.value.length > 0;
    this.emailSubmitButton.classList.toggle('is-visible', hasText);
  }

  async handleSubmit(e) {
    e.preventDefault();
    const email = this.emailInput.value.trim();

    if (!validateEmail(email)) {
      this.emailInput.classList.add('error');
      return;
    }
    this.emailInput.classList.remove('error');

    const postData = {
      email,
      productId: this.productId,
      variantId: this.variantId,
      marketing_consent: false,
    };

    try {
      const response = await fetch('https://services.sophiawebster.com/api/coming-soon', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postData),
      });

      if (response.ok) {
        this.triggerToast({ success: true });
      } else {
        this.triggerToast({ success: false });
      }
    } catch (error) {
      this.triggerToast({ success: false });
    } finally {
      window.CenteredPopovers.wrapper.hide();
    }
  }

  triggerToast({ success } = {}) {
    if (success) {
      showToast('You’re on the list! We’ll let you know the moment it launches.', undefined, 9000);
    } else {
      showToast(
        'Creating a stock alert failed. Please try again, or contact customer services if the problem persists.',
      );
    }
  }

  resetForm() {
    if (this.form) {
      this.form.reset();
      this.emailInput.classList.remove('error');
    }
  }
};

elabs.onJavascriptReady(() => {
  const popoverElement = document.querySelector('[data-centered-popover="coming-soon-alert"]');
  if (!popoverElement) {
    return;
  }

  const registerPopover = () => {
    window.CenteredPopovers['coming-soon-alert'] = new elabs.ComingSoonPopover(popoverElement);
  };

  if (window.__CenteredPopoversWrapperReady) {
    registerPopover();
  } else {
    window.addEventListener('CenteredPopoversWrapper:ready', registerPopover, { once: true });
  }
});
